import { useAppDispatch, useAppSelector } from 'app/hooks';
import FooterMenu from 'components/Commons/FooterMenu';
import Header from 'components/Commons/Header';
import AuthPage from 'features/auth/pages/AuthPage';
import ChangePasswordPage from 'features/auth/pages/ChangePasswordPage';
import BetFormMainTab from 'features/home/components/BetForm/BetFormMainTab';
import BetSlipForm from 'features/home/components/BetForm/BetSlipForm';
import MyBetsForm from 'features/home/components/BetForm/MyBetsForm';
import TransactionModal from 'features/home/components/Modals/TransactionModal';
import { onChangeAuthPage, setShowSubMenu } from 'features/home/homeSlice';
import useUserDetail from 'hooks/useUserDetail';
import React, { useState } from 'react';
import { platformStates } from 'redux/platformSlice';

interface ListBetPageProps {}

const ListBetPage: React.FunctionComponent<ListBetPageProps> = () => {
  const [isShowChangePasswordForm, setIsShowChangePasswordForm] = useState<boolean>(false);
  const { isUserLoggedIn } = useUserDetail();
  const dispatch = useAppDispatch();
  const platform = useAppSelector(platformStates);
  const onShowChangePasswordPage = () => {
    if (isUserLoggedIn) setIsShowChangePasswordForm(true);
  };
  const [currentTab, setCurrentTab] = React.useState<number>(1);
  const changeTab = (tab: number): void => {
    setCurrentTab(tab);
  };
  const closeForm = (): void => {
    dispatch(onChangeAuthPage(-1));
    dispatch(setShowSubMenu(false));
    setIsShowChangePasswordForm(false);
  };
  return (
    <div className="listBet-page relative">
      <i className="version">Version 1.0</i>
      <div className={`body-waraper`}>
        <Header isCasino onShowChangePasswordPage={onShowChangePasswordPage} />
        <div className="bet-form">
          <BetFormMainTab currentTab={currentTab} changeTab={changeTab} />
          {currentTab === 1 && <BetSlipForm />}
          {currentTab === 2 && <MyBetsForm />}
        </div>
        <FooterMenu
          isUserLogin={isUserLoggedIn}
          isBetPage
          onShowChangePasswordPage={onShowChangePasswordPage}
        />
      </div>
      <ChangePasswordPage isShow={isShowChangePasswordForm} closePage={closeForm} />
      <AuthPage />
      <TransactionModal />
    </div>
  );
};

export default ListBetPage;
